import getEnvironment from "./getEnvironment";

const isDevMode = (): boolean =>
  getEnvironment() === "localhost" && !process.env.VIRTUAL_DOMAIN;

const getBuyerDomain = (isToUseAuthZero = false): URL => {
  if (isDevMode()) {
    return new URL("https://cms.uat.britishcarauctions.net/api");
  }
  if (typeof process.env.VIRTUAL_DOMAIN === "string") {
    if (isToUseAuthZero) {
      return new URL("api", process.env.VIRTUAL_DOMAIN);
    }

    const buyerDomainUrl = new URL(
      `${process.env.URL_SUFFIX}/api`,
      `${process.env.VIRTUAL_DOMAIN}`
    );

    return buyerDomainUrl;
  }
  return null;
};

export default getBuyerDomain;
